import React, { useEffect, useState } from 'react'
import { Button, Card, Modal, Tabs } from 'antd'
import CreatePage from '../components/PageBuilder/CreatePage'
import { PageBuilderServices } from '../Services/PageBuilderServices'
import { notify } from '../customs/NotifyProvider'
import ListAllPage from '../components/PageBuilder/ListAllPage'
import { navigate } from '../../navigation'
import TopMenu from '../components/PageBuilder/TopMenu'

const PageBuilder = () => {
    const [open, setOpen] = useState(false)
    const [editingPage, setEditingPage] = useState(null)

    const [pages, setPages] = useState([])
    const [blogs, setBlogs] = useState([])
    const [others, setOthers] = useState([])


    const getAllPage = async () => {
        try {
            const request = await PageBuilderServices.getAllPage()
            const data = request.data || []

            const pageCollection = []
            const blogCollection = []
            const otherCollection = []

            data.forEach(item => {
                const slug = item.slug || ''

                // BLOG
                if (
                    slug.startsWith('blog/') ||
                    slug.startsWith('blogs/')
                ) {
                    blogCollection.push(item)
                }
                // PAGE (no slash at all)
                else if (!slug.includes('/')) {
                    pageCollection.push(item)
                }
                // OTHER (has slash but not blog)
                else {
                    otherCollection.push(item)
                }
            })

            setPages(pageCollection)
            setBlogs(blogCollection)
            setOthers(otherCollection)

        } catch (error) {
            console.error(error)
        }
    }

    const handleDelete = async () => {
        try {
            console.log(editingPage);

            const request = await PageBuilderServices.deletePBDetails(editingPage.id);
            if (request?.status) {
                notify.success("Deleted", request.message)
                getAllPage()
                setOpen(false)
                setEditingPage(null)
            } else {
                notify.error("Something went wrong", request.message)
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        getAllPage()
    }, [])

    const handleSubmit = async (values) => {
        try {
            let request

            if (editingPage) {
                // EDIT MODE
                request = await PageBuilderServices.updatePBDetails(
                    editingPage.id,
                    values
                )
            } else {
                // CREATE MODE
                request = await PageBuilderServices.addPBDetails(values)
            }

            if (request?.status) {
                notify.success('Success', request.message)
                setOpen(false)
                setEditingPage(null)
                getAllPage()
            } else {
                notify.error('Error', request.message)
            }
        } catch (error) {
            console.error(error)
            notify.error('Error', 'Something went wrong')
        }
    }

    const handleManagePage = async (record) => {
        console.log(record);
        navigate('/page-builder/manage', { state: { record } });
    };


    return (
        <Card
            title="Page Builder"
            extra={
                <Button
                    type="primary"
                    ghost
                    onClick={() => {
                        setEditingPage(null)
                        setOpen(true)
                    }}
                >
                    Create Page
                </Button>
            }
        >
            <Modal
                title={editingPage ? 'Edit Page' : 'Create Page'}
                open={open}
                footer={null}
                onCancel={() => {
                    setOpen(false)
                    setEditingPage(null)
                }}
                destroyOnHidden
            >
                <CreatePage
                    onSubmit={handleSubmit}
                    initialValues={editingPage}
                    isEdit={!!editingPage}
                    onDelete={handleDelete}
                />
            </Modal>

            <Tabs
                defaultActiveKey="pages"
                items={[
                    {
                        key: 'pages',
                        label: 'Pages',
                        children: (
                            <ListAllPage
                                data={pages}
                                onEdit={(row) => {
                                    setEditingPage(row)
                                    setOpen(true)
                                }}
                                onManage={handleManagePage}
                            />
                        ),
                    },
                    {
                        key: 'blogs',
                        label: 'Blogs',
                        children: (
                            <ListAllPage
                                data={blogs}
                                onEdit={(row) => {
                                    setEditingPage(row)
                                    setOpen(true)
                                }}
                                onManage={handleManagePage}
                            />
                        ),
                    },
                    {
                        key: 'others',
                        label: 'Others',
                        children: (
                            <ListAllPage
                                data={others}
                                onEdit={(row) => {
                                    setEditingPage(row)
                                    setOpen(true)
                                }}
                                onManage={handleManagePage}
                            />
                        ),
                    },
                    {
                        key: 'top_menu',  
                        label: 'Top Menu',
                        children: (
                            <TopMenu />
                        ),
                    },
                ]}
            />

        </Card>
    )
}

export default PageBuilder
